import React, { useEffect, useState } from "react";
import DashboardListItem from "components/DashboardListItem";
import ChipButton from "elements/ChipButton";
import useStyles from "./styles";
import InfoDialog from "components/InfoDialog";

const DashboardList = (props) => {
  const {
    chipButtonSection,
    notificationListSection,
    notificationListNewClass,
  } = useStyles();
  const {
    tabIndex,
    cardList,
    chipButtons,
    coOrdinates,
    expandListFromMap,
    indexFromMap,
    chipButtonTabIndex,
    searchIsOpen,
    searchTerm = ""
  } = props;
  
  const [cardListData, setCardListData] = useState(cardList || []);
  const [tabIndexChild1, setTabIndexChild1] = useState(0);
  const [chipButtonTabIndex1, setChipButtonTabIndex1] =
    useState(chipButtonTabIndex);
  const [selected, setSelected] = useState(null);
  const [infoVideoTitleListData, setInfoVideoTitleListData] = useState();
  const [viewAllIsOpen, setViewAllIsOpen] = useState(false);
  const [dialogBoxTabIndexData, setDialogBoxTabIndexData] = useState(null);

  useEffect(() => {
    if (cardList && Array.isArray(cardList)) {
      setCardListData(cardList);
    } else {
      setCardListData([]);
    }
    setSelected(null);
  }, [cardList]);


  useEffect(() => {
    // When popup is closed from map, reset the sidebar selection
    if (indexFromMap === null) {
      setSelected(null);
    } else {
      setSelected(indexFromMap);
    }
    setTabIndexChild1(tabIndex);
    setChipButtonTabIndex1(chipButtonTabIndex);
  }, [expandListFromMap, indexFromMap, tabIndex, chipButtonTabIndex]);

  const handleChipButton = (data, index) => {
    props.handleChipButton(data, index);
  };

  const handleIsOpen = (index, tabIndexChild, data, chipButtonTabIndex) => {
    
    if (selected === index) {
      setSelected(null);
      props.handleClickFromListToMap(null);
    } else {
      setSelected(index);
      props.handleClickFromListToMap(data);
    }

    setTabIndexChild1(tabIndexChild);
    setChipButtonTabIndex1(chipButtonTabIndex);
    setInfoVideoTitleListData(data);
    props.handleClickDrawRoute(data);
  };


  const handleViewAll = (tabIndexData) => {
    setViewAllIsOpen(!viewAllIsOpen);
    setDialogBoxTabIndexData(tabIndexData);
  };

  const filteredData = cardListData && Array.isArray(cardListData)
    ? cardListData.filter(item => {
      if (!item) return false;

      const searchLower = searchTerm.toLowerCase();

      // Search across multiple relevant fields
      return (
        (item.title && item.title.toLowerCase().includes(searchLower)) ||
        (item.source && item.source.toLowerCase().includes(searchLower)) ||
        (item.destination && item.destination.toLowerCase().includes(searchLower)) ||
        (item.driver && item.driver.toLowerCase().includes(searchLower)) ||
        (item.timeStamp && item.timeStamp.toLowerCase().includes(searchLower))
      );
    })
    : [];

  return (
    <>
      <div className={chipButtonSection}>
        {tabIndex === 0 || tabIndex === 3
          ? chipButtons && chipButtons.length > 0
            ? chipButtons.map((item, index) => {
              return (
                <ChipButton
                  key={index}
                  data={item}
                  index={index}
                  handleClick={handleChipButton}
                />
              );
            })
            : null
          : null}
      </div>
      <div
        className={notificationListSection}
        style={{
          height: !searchIsOpen ? "calc(100vh - 249px)" : "calc(100vh - 300px)",
        }}
      >
        {filteredData.length > 0 ? (
          filteredData.map((item, index) => {
            return (
              <DashboardListItem
                key={index}
                data={item}
                tabIndex={tabIndex}
                index={index}
                handleIsOpen={handleIsOpen}
                selected={
                  tabIndexChild1 === tabIndex &&
                  chipButtonTabIndex1 === chipButtonTabIndex
                    ? selected
                    : null
                }
                handleViewAll={handleViewAll}
                chipButtonTabIndex={chipButtonTabIndex}
              />
            );
          })
        ) : (
          <div>
            <span style={{ padding: 10, color: "gray" }}>
              {searchTerm ? "No matching results found" : "No Result Found"}
            </span>
          </div>
        )}
      </div>
      {viewAllIsOpen && (
        <InfoDialog
          handleViewAll={handleViewAll}
          dialogBoxTabIndexData={dialogBoxTabIndexData}
          tabIndex={tabIndex}
          infoVideoTitleListData={infoVideoTitleListData}
          coOrdinates={coOrdinates}
        />
      )}
    </>
  );
};
export default DashboardList;









// import React, { useEffect, useState } from "react";
// import DashboardListItem from "components/DashboardListItem";
// import ChipButton from "elements/ChipButton";
// import useStyles from "./styles";
// import InfoDialog from "components/InfoDialog";

// const DashboardList = (props) => {
//   const {
//     chipButtonSection,
//     notificationListSection,
//     notificationListNewClass,
//   } = useStyles();
//   const {
//     tabIndex,
//     cardList,
//     chipButtons,
//     coOrdinates,
//     expandListFromMap,
//     indexFromMap,
//     chipButtonTabIndex,
//     searchIsOpen,
//     searchTerm = ""
//   } = props;

//   
//   
//   
//   

//   const [cardListData, setCardListData] = useState(cardList || []);
//   const [selected, setSelected] = useState(null);
//   const [infoVideoTitleListData, setInfoVideoTitleListData] = useState();
//   const [viewAllIsOpen, setViewAllIsOpen] = useState(false);
//   const [dialogBoxTabIndexData, setDialogBoxTabIndexData] = useState(null);

//   useEffect(() => {
//     if (cardList && Array.isArray(cardList)) {
//       setCardListData(cardList);
//     } else {
//       setCardListData([]);
//     }
//   }, [cardList]);

//   useEffect(() => {
//     // Reset selection when tab or chip button changes
//     setSelected(null);
//     props.handleClickFromListToMap(null);
//     props.handleClickDrawRoute(null);
//   }, [tabIndex, chipButtonTabIndex]);

//   useEffect(() => {
//     // Handle selection from map
//     if (indexFromMap !== null && indexFromMap !== undefined) {
//       setSelected(indexFromMap);
//     }
//   }, [indexFromMap]);

//   const handleChipButton = (data, index) => {
//     props.handleChipButton(data, index);
//   };

//   const handleIsOpen = (index, data) => {
//     
//     
    
//     if (selected === index) {
//       setSelected(null);
//       props.handleClickFromListToMap(null);
//       props.handleClickDrawRoute(null);
//     } else {
//       setSelected(index);
//       props.handleClickFromListToMap(data);
//       props.handleClickDrawRoute(data);
//     }

//     setInfoVideoTitleListData(data);
//   };

//   const handleViewAll = (tabIndexData) => {
//     setViewAllIsOpen(!viewAllIsOpen);
//     setDialogBoxTabIndexData(tabIndexData);
//   };

//   const filteredData = cardListData && Array.isArray(cardListData)
//     ? cardListData.filter(item => {
//       if (!item) return false;

//       const searchLower = searchTerm.toLowerCase();

//       // Search across multiple relevant fields
//       return (
//         (item.title && item.title.toLowerCase().includes(searchLower)) ||
//         (item.source && item.source.toLowerCase().includes(searchLower)) ||
//         (item.destination && item.destination.toLowerCase().includes(searchLower)) ||
//         (item.driver && item.driver.toLowerCase().includes(searchLower)) ||
//         (item.timeStamp && item.timeStamp.toLowerCase().includes(searchLower))
//       );
//     })
//     : [];

//   return (
//     <>
//       <div className={chipButtonSection}>
//         {tabIndex === 0 || tabIndex === 3
//           ? chipButtons && chipButtons.length > 0
//             ? chipButtons.map((item, index) => {
//               return (
//                 <ChipButton
//                   key={index}
//                   data={item}
//                   index={index}
//                   handleClick={handleChipButton}
//                 />
//               );
//             })
//             : null
//           : null}
//       </div>
//       <div
//         className={notificationListSection}
//         style={{
//           height: !searchIsOpen ? "calc(100vh - 249px)" : "calc(100vh - 300px)",
//         }}
//       >
//         {filteredData.length > 0 ? (
//           filteredData.map((item, index) => {
//             return (
//               <DashboardListItem
//                 key={index}
//                 data={item}
//                 tabIndex={tabIndex}
//                 index={index}
//                 handleIsOpen={() => handleIsOpen(index, item)}
//                 selected={selected === index}
//                 handleViewAll={handleViewAll}
//                 chipButtonTabIndex={chipButtonTabIndex}
//               />
//             );
//           })
//         ) : (
//           <div>
//             <span style={{ padding: 10, color: "gray" }}>
//               {searchTerm ? "No matching results found" : "No Result Found"}
//             </span>
//           </div>
//         )}
//       </div>
//       {viewAllIsOpen && (
//         <InfoDialog
//           handleViewAll={handleViewAll}
//           dialogBoxTabIndexData={dialogBoxTabIndexData}
//           tabIndex={tabIndex}
//           infoVideoTitleListData={infoVideoTitleListData}
//           coOrdinates={coOrdinates}
//         />
//       )}
//     </>
//   );
// };

// export default DashboardList;


















// import React, { useEffect, useState } from "react";
// import DashboardListItem from "components/DashboardListItem";
// import ChipButton from "elements/ChipButton";
// import useStyles from "./styles";
// import InfoDialog from "components/InfoDialog";

// const DashboardList = (props) => {
//   const {
//     chipButtonSection,
//     notificationListSection,
//     notificationListNewClass,
//   } = useStyles();
//   const {
//     tabIndex,
//     cardList,
//     chipButtons,
//     coOrdinates,
//     expandListFromMap,
//     indexFromMap,
//     chipButtonTabIndex,
//     searchIsOpen,
//     searchTerm = ""
//   } = props;

//   

//   const [cardListData, setCardListData] = useState(cardList || []);
//   const [chipButtonTabIndex1, setChipButtonTabIndex1] = useState(chipButtonTabIndex);
//   const [selected, setSelected] = useState(null);
//   const [selectedTabIndex, setSelectedTabIndex] = useState(null); // Add this state
//   const [infoVideoTitleListData, setInfoVideoTitleListData] = useState();
//   const [viewAllIsOpen, setViewAllIsOpen] = useState(false);
//   const [dialogBoxTabIndexData, setDialogBoxTabIndexData] = useState(null);

//   useEffect(() => {
//     if (cardList && Array.isArray(cardList)) {
//       setCardListData(cardList);
//     } else {
//       setCardListData([]);
//     }
//     setSelected(null);
//     setSelectedTabIndex(null); // Reset selected tab when cardList changes
//   }, [cardList]);

//   useEffect(() => {
//     if (selected === indexFromMap) {
//       setSelected(null);
//       setSelectedTabIndex(null);
//     } else {
//       setSelected(indexFromMap);
//       setSelectedTabIndex(tabIndex); // Set the current tab as selected tab
//     }
//     setChipButtonTabIndex1(chipButtonTabIndex);
//   }, [expandListFromMap, indexFromMap]);

//   const handleChipButton = (data, index) => {
//     props.handleChipButton(data, index);
//   };

//   const handleIsOpen = (index, tabIndexChild, data, chipButtonTabIndex) => {
//     
//     
//     
    
//     if (selected === index && selectedTabIndex === tabIndexChild) {
//       setSelected(null);
//       setSelectedTabIndex(null);
//       props.handleClickFromListToMap(null);
//     } else {
//       setSelected(index);
//       setSelectedTabIndex(tabIndexChild); // Store which tab this selection belongs to
//       props.handleClickFromListToMap(data);
//     }

//     setChipButtonTabIndex1(chipButtonTabIndex);
//     setInfoVideoTitleListData(data);
//     props.handleClickDrawRoute(data);
//   };

//   const handleViewAll = (tabIndexData) => {
//     setViewAllIsOpen(!viewAllIsOpen);
//     setDialogBoxTabIndexData(tabIndexData);
//   };

//   const filteredData = cardListData && Array.isArray(cardListData)
//     ? cardListData.filter(item => {
//       if (!item) return false;

//       const searchLower = searchTerm.toLowerCase();

//       return (
//         (item.title && item.title.toLowerCase().includes(searchLower)) ||
//         (item.source && item.source.toLowerCase().includes(searchLower)) ||
//         (item.destination && item.destination.toLowerCase().includes(searchLower)) ||
//         (item.driver && item.driver.toLowerCase().includes(searchLower)) ||
//         (item.timeStamp && item.timeStamp.toLowerCase().includes(searchLower))
//       );
//     })
//     : [];

//   return (
//     <>
//       <div className={chipButtonSection}>
//         {tabIndex === 0 || tabIndex === 3
//           ? chipButtons && chipButtons.length > 0
//             ? chipButtons.map((item, index) => {
//               return (
//                 <ChipButton
//                   key={index}
//                   data={item}
//                   index={index}
//                   handleClick={handleChipButton}
//                 />
//               );
//             })
//             : null
//           : null}
//       </div>
//       <div
//         className={notificationListSection}
//         style={{
//           height: !searchIsOpen ? "calc(100vh - 249px)" : "calc(100vh - 300px)",
//         }}
//       >
//         {filteredData.length > 0 ? (
//           filteredData.map((item, index) => {
//             return (
//               <DashboardListItem
//                 key={index}
//                 data={item}
//                 tabIndex={tabIndex}
//                 index={index}
//                 handleIsOpen={handleIsOpen}
//                 selected={
//                   selectedTabIndex === tabIndex && // Check if selected item belongs to current tab
//                   chipButtonTabIndex1 === chipButtonTabIndex &&
//                   selected === index
//                     ? selected
//                     : null
//                 }
//                 handleViewAll={handleViewAll}
//                 chipButtonTabIndex={chipButtonTabIndex}
//               />
//             );
//           })
//         ) : (
//           <div>
//             <span style={{ padding: 10, color: "gray" }}>
//               {searchTerm ? "No matching results found" : "No Result Found"}
//             </span>
//           </div>
//         )}
//       </div>
//       {viewAllIsOpen && (
//         <InfoDialog
//           handleViewAll={handleViewAll}
//           dialogBoxTabIndexData={dialogBoxTabIndexData}
//           tabIndex={tabIndex}
//           infoVideoTitleListData={infoVideoTitleListData}
//           coOrdinates={coOrdinates}
//         />
//       )}
//     </>
//   );
// };
// export default DashboardList;